/**
 * OpsTabs — shared tab strip that unifies the daily-operations pages
 * (Today / Schedule / Attendance / Check-in / Progress) into one section.
 * Rendered at the top of each page so coaches hop between them in one tap
 * instead of hunting the sidebar.
 */
import { NavLink } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const TABS = [
    { to: "/coach/today", label: "Today", perm: "view_attendance" },
    { to: "/coach/schedule", label: "Schedule", perm: "view_schedule" },
    { to: "/coach/attendance", label: "Attendance", perm: "view_attendance" },
    { to: "/coach/check-in", label: "Check-in", perm: "view_attendance" },
    { to: "/coach/progress-updates", label: "Progress", perm: "view_clients" },
    { to: "/coach/renewal-forecast", label: "Forecast", perm: "view_billing" },
];

export default function OpsTabs() {
    const { user } = useAuth();
    const isOwner = user?.role === "owner";
    const can = (key) => isOwner || !!user?.permissions?.[key];
    const tabs = TABS.filter((t) => can(t.perm));
    if (tabs.length < 2) return null;
    return (
        <nav
            data-testid="ops-tabs"
            className="flex items-center gap-1 overflow-x-auto -mx-1 px-1 pb-3 mb-4 border-b border-zinc-900"
        >
            {tabs.map((t) => (
                <NavLink
                    key={t.to}
                    to={t.to}
                    data-testid={`ops-tab-${t.label.toLowerCase()}`}
                    className={({ isActive }) =>
                        `shrink-0 px-3.5 py-1.5 text-[11px] tracking-[0.18em] uppercase transition-colors border ${
                            isActive
                                ? "border-brand-red bg-brand-red/10 text-white"
                                : "border-transparent text-zinc-400 hover:text-white hover:border-zinc-700"
                        }`
                    }
                >
                    {t.label}
                </NavLink>
            ))}
        </nav>
    );
}
